// Translation: Utility > Feedback (German)
export default Object.freeze({
	hint: ''
})
